import { SceneContextMenuData } from "@/modes/sheet-mode/scene-context-menu/use-scene-context-menu";
import {
  GUID,
  IElementGenericImgSheet,
  IElementImg360,
  type IElementGenericOdometryPath,
} from "@faro-lotv/ielement-types";
import { ThreeEvent } from "@react-three/fiber";
import type { JSX } from "react";
import { Box3, Plane } from "three";
import {
  OdometryPathRenderer,
  PathWaypointTarget,
} from "./odometry-path-renderer";

type Props = {
  /** The paths to render*/
  paths: IElementGenericOdometryPath[];

  /** sheet whose elevation will be used to render the paths */
  sheetForElevation?: IElementGenericImgSheet;

  /** The currently active paths */
  activePathIds?: GUID[];

  /** Optional clipping planes */
  clippingPlanes?: Plane[];

  /** Callback when a pano placeholder is hovered */
  onPlaceholderHovered?(pano: IElementImg360): void;

  /** Callback when a pano placeholder is clicked */
  onPlaceholderClicked?(target: PathWaypointTarget): void;

  /** Callback when a context menu is requested */
  onSceneContextMenu?(contextMenuData: SceneContextMenuData): void;

  /** Callback when the path is activated */
  onPathClick?(
    event: ThreeEvent<MouseEvent>,
    path: IElementGenericOdometryPath,
    boundingBox: Box3,
  ): void;
};

/**
 * @returns the odometric paths for the currently active day
 */
export function OdometryPathsRenderer({
  paths,
  sheetForElevation,
  activePathIds,
  clippingPlanes,
  onPlaceholderHovered,
  onPlaceholderClicked,
  onSceneContextMenu,
  onPathClick,
}: Props): JSX.Element | null {
  if (!paths.length) {
    return null;
  }

  return (
    <>
      {paths.map((path) => (
        <OdometryPathRenderer
          key={path.id}
          path={path}
          sheetForElevation={sheetForElevation}
          activeRecordingIds={activePathIds}
          onPathClick={onPathClick}
          onPlaceholderClicked={onPlaceholderClicked}
          onSceneContextMenu={onSceneContextMenu}
          onPlaceholderHovered={onPlaceholderHovered}
          clippingPlanes={clippingPlanes}
        />
      ))}
    </>
  );
}
